import { render, staticRenderFns } from "./AgentWithdrawalRequestStatistics.vue?vue&type=template&id=01168aaa&scoped=true&"
import script from "./AgentWithdrawalRequestStatistics.vue?vue&type=script&lang=js&"
export * from "./AgentWithdrawalRequestStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AgentWithdrawalRequestStatistics.vue?vue&type=style&index=0&id=01168aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01168aaa",
  null
  
)

export default component.exports